module.exports = __webpack_public_path__ + "static/media/box.fcd43030.svg";